import { useTranslation } from 'react-i18next';
import Button from 'wtb-components/Button';
import Typography from 'wtb-components/Typography';

import notFoundImage from 'assets/images/lost.svg';

import styles from './NotFound.module.css';

export default function NotFound() {
  const { t: translate } = useTranslation();

  return (
    <div className={styles.root}>
      <img
        data-testid="not-found-image"
        alt="not found"
        className={styles.image}
        src={notFoundImage}
      />

      <Typography component="h5" variant="h5" align="center" className={styles.header} id="error-title">
        {translate('notFound.header')}
      </Typography>
      <Typography component="p" variant="body1" align="center" className={styles.text} id="error-description">
        {translate('notFound.subtitle')}
      </Typography>

      <Button
        className={styles.button}
        id="home-button"
        render={<a href="https://www.waytobill.com" />}
      >
        {translate('notFound.action')}
      </Button>
    </div>
  );
}
